import { Tab, Tabs, styled } from '@mui/material'
import { muiTabsHeight } from '../../constants/constants'
import { ReactElement } from 'react'

interface TabPanelProps {
    children?: React.ReactNode
    index: number
    value: number
    styles?: React.CSSProperties
}

export const CustomTabPanel = (props: TabPanelProps): ReactElement => {
    const { children, value, index, styles, ...other } = props

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            tabIndex={0}
            {...other}
            style={{
                borderRight: '1px solid rgba(0, 0, 0, 0.05)',
                borderLeft: '1px solid rgba(0, 0, 0, 0.05)',
                borderBottom: '1px solid rgba(0, 0, 0, 0.05)',
                padding: '5px',
                height: `calc(100% - ${muiTabsHeight})`,
                overflow: 'auto',
                ...styles,
            }}
        >
            {value === index && children}
        </div>
    )
}

export const a11yProps = (
    index: number,
): { id: string; 'aria-controls': string } => {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    }
}

export const CustomTab = styled((props: any) => (
    <Tab disableRipple {...props} />
))(({ theme }) => ({
    textTransform: 'none',
    minWidth: 0,
    [theme.breakpoints.up('sm')]: {
        minWidth: 0,
    },
    fontWeight: theme.typography.fontWeightMedium,
    marginRight: theme.spacing(1),
    '&.Mui-selected': {
        fontWeight: theme.typography.fontWeightMedium,
        color: theme.palette.primary.main,
    },
    '&.Mui-focusVisible': {
        backgroundColor: 'rgba(100, 95, 228, 0.32)',
    },
    minHeight: muiTabsHeight,
    paddingTop: '6px',
    paddingBottom: '6px',
    paddingLeft: '0px',
    paddingRight: '0px',
    marginLeft: '12px',
}))

export const CustomTabs = styled((props: any) => <Tabs {...props} />)(
    ({ theme }) => ({
        borderBottom: '1px solid rgba(0, 0, 0, 0.05)',
        minHeight: muiTabsHeight,
        '& .MuiTabs-indicator': {
            display: 'flex',
            justifyContent: 'center',
            backgroundColor: 'transparent',
            '& > span': {
                maxWidth: '100%',
                width: '100%',
                backgroundColor: theme.palette.primary.main,
            },
        },
    }),
)
